import {h, Fragment} from "preact"
export default function RangeInput({ className, ...props }) {
    return <input type="number" className={`field-input w-full ${className}`} {...props} />
}